export default value => (value && `${value}`.trim()) || value === 0 ?
  undefined : 'Field is required'
